import { ObjectMap } from '@ringcentral-integration/core/lib/ObjectMap';

export const webphoneMessages = ObjectMap.prefixKeys(['parked'], 'webphone');

export default webphoneMessages;
